module.exports = __webpack_public_path__ + "static/media/aishani.3ae998e8.png";